import AppHome from '../containers/AppHome/AppHome';
import {HOME_TAB} from '../components/LeftNav/constants';

export const AppHomeRoutes = [
	{
		...AppHome,
		path: '/cc/canvas', // used to be /webapps/fred
		exact: true,
		tab: HOME_TAB,
		titleId: 'app.document.title.FRED',
	},
	{
		...AppHome,
		path: '/cc/photoshop',
		exact: true,
		tab: HOME_TAB,
		titleId: 'app.document.title.PHSP',
	},
	{
		...AppHome,
		path: '/cc/illustrator',
		exact: true,
		tab: HOME_TAB,
		titleId: 'app.document.title.ILST',
	},
];
